import React from "react";
import Navbar from "../../components/homecomponentes/navBar";
import './index.css';
import Hero from "../../components/homecomponentes/hero";
import Footer from "../../components/homecomponentes/footer";

function HomePage() {
    return(
        <div className="home-container">
            <div>
                <Navbar/>
                <Hero/>
            </div>
            <Footer/>
        </div>
    )
}


export default HomePage;